import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { NotificationsPanel } from '@decisiv/ui-components';
import PortalLogin from './PortalLogin';
import PasswordReset from './PasswordReset';
import Password from './Password';
import { MainContainer } from './components/styledComponents';

function Login({ dealerId, csrfToken, defaultScreen }) {
  const PORTAL_LOGIN = 'PortalLogin';
  const PASSWORD_RESET = 'PasswordReset';
  const PASSWORD = 'Password';

  const [screen, setScreen] = useState(defaultScreen);

  return (
    <MainContainer>
      <NotificationsPanel marginTop={4} zIndex={1000} />

      {screen === PORTAL_LOGIN && (
        <PortalLogin
          dealerId={dealerId}
          csrfToken={csrfToken}
          requestPasswordClick={() => setScreen(PASSWORD_RESET)}
        />
      )}
      {screen === PASSWORD_RESET && (
        <PasswordReset
          csrfToken={csrfToken}
          backLoginClick={() => setScreen(PORTAL_LOGIN)}
        />
      )}
      {screen === PASSWORD && (
        <Password
          csrfToken={csrfToken}
          backLoginClick={() => setScreen(PORTAL_LOGIN)}
        />
      )}
    </MainContainer>
  );
}

Login.propTypes = {
  dealerId: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  defaultScreen: PropTypes.string,
};

Login.defaultProps = {
  dealerId: '',
  defaultScreen: 'PortalLogin',
};

export default Login;
